import { api } from './config';
import { ApiResponse } from '../types';
import { DeletedProjectItem, DeletedSampleRequestItem } from '../types/deleted.types';

/**
 * 삭제된(Deleted) 항목 API — admin(role=admin) 전용. soft-deleted 프로젝트/샘플요청 조회/복원.
 * 영구삭제 없음(복원만 제공). 백엔드: /admin/deleted/*
 */
export const deletedApi = {
  getDeletedProjects: (params?: { keyword?: string; page?: number; size?: number }) =>
    api.get<ApiResponse<DeletedProjectItem[]>>('/admin/deleted/projects', { params }),

  getDeletedSampleRequests: (params?: { keyword?: string; page?: number; size?: number }) =>
    api.get<ApiResponse<DeletedSampleRequestItem[]>>('/admin/deleted/sample-requests', { params }),

  restoreProject: (projectId: number) =>
    api.post<ApiResponse>(`/admin/deleted/projects/${projectId}/restore`),

  restoreSampleRequest: (requestId: number) =>
    api.post<ApiResponse>(`/admin/deleted/sample-requests/${requestId}/restore`),
};
